import * as React from "react";
import { getAgentDisplayName, parseAgentOrigin } from "../../utils/agent-chat-utils";
import { AppContext } from "../../setup/context";
import { Preference } from "../../setup/preference";
import "../../styles/component/quick-agent-chat-panel/QuickAgentChatPanel.scss";

interface InlineSearchChatProps {
    agentUrl: string;
    query: string;
}

export const InlineSearchChat: React.FC<InlineSearchChatProps> = ({ agentUrl, query }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const chatOrigin = React.useMemo(() => parseAgentOrigin(agentUrl), [agentUrl]);
    const context = React.useContext(AppContext);
    const [agentName] = React.useState(() => getAgentDisplayName(context.hasLab(Preference.Lab.AgenticUI)));

    if (!chatOrigin) {
        return null;
    }

    return (
        <div className={`qa-inline-chat-container ${isExpanded ? "qa-inline-chat-container--expanded" : ""}`}>
            <iframe
                key={query}
                className={`qa-inline-chat-iframe ${isExpanded ? "qa-inline-chat-iframe--expanded" : ""}`}
                title={`${agentName} Chat`}
                src={`${agentUrl}?initialPrompt=${encodeURIComponent(query)}&showInitialPromptMessage=false`}
                allow={`clipboard-read ${chatOrigin}; clipboard-write ${chatOrigin}`}
                width="100%"
            />
            <button
                className="qa-inline-chat-toggle"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}
            >
                {isExpanded ? "▲ Collapse" : "▼ Expand"}
            </button>
        </div>
    );
};
